import moment from "moment";
import { generateUUID } from "utils/appUtil";


const initialState = {
  searchResult: [],
  readBy: [],
  selectedItem: {},
  twilioToken: "",
  mapType: "PAGE",
  callNotification: undefined,
  saveRecordingNotification: undefined,
  twilioVideoURL: undefined,
  searchLoading: false,
  pageConnection: undefined,
  searchPage: {offset: 0, limit: 10, scroll: true},
  forwardPopupSearchPage: {offset: 0, limit: 10, scroll: true},
  searchArgs: {paginate: false},
  forwardSearchArgs: {paginate: false},
  requestIds: {
    page: generateUUID(),
    message: generateUUID(),
  }
};

const getSearch = (state: SearchState): SearchState => ({
  ...state,
  searchLoading: true,
});

const getSelectedSearchItem = (
  state: SearchState,
  action: any
): SearchState => ({
  ...state,
  selectedItem: action.payload,
});

const getSearchResults = (state: SearchState, action: any): SearchState => {
  let read, pending = undefined;
  let results = action.payload;
  let {searchPage, searchArgs} = state;
  let merged = state?.searchArgs?.paginate ? [...state.searchResult, ...results]: results;
  // Friend-page results are merged into the same list, so the same page can
  // arrive twice — keep the first occurrence of each pageId.
  let searchResult = merged.filter((item: any, index: number, self: any[]) =>
    index === self.findIndex((t: any) => t.pageId === item.pageId)
  );
  return{
    ...state,
    searchResult,
    searchPage: action.payload.length < searchPage.limit ? {...searchPage, scroll: false}: {...searchPage, offset: searchPage.offset + searchPage.limit},
    searchArgs: (action.payload.length < searchPage.limit && (searchArgs?.args?.read !== read || searchArgs?.args?.pending !== pending)) ? {...searchArgs, paginate: true, args: {read, pending}}: searchArgs,
    selectedItem:
    searchResult.length > 0
        ? state.selectedItem?.pageId
          ? searchResult.find(
              (item: SelectedSearchItem) =>
                item.pageId === state.selectedItem?.pageId
            )
          : searchResult[0]
        : {},
}}
const getForwardPopupSearchResults = (state: SearchState, action: any): SearchState => {
  let read, pending = undefined;
  let results = action.payload;
  let {forwardPopupSearchPage, forwardSearchArgs} = state;
  let forwardPopupPagesResult = state?.forwardSearchArgs?.paginate ? [...state.forwardPopupPagesResult, ...results]: results;
  return{
    ...state,
    forwardPopupPagesResult,
    forwardPopupSearchPage: action.payload.length < forwardPopupSearchPage.limit ? {...forwardPopupSearchPage, scroll: false}: {...forwardPopupSearchPage, offset: forwardPopupSearchPage.offset + forwardPopupSearchPage.limit},
    forwardSearchArgs: (action.payload.length < forwardPopupSearchPage.limit && (forwardSearchArgs?.args?.read !== read || forwardSearchArgs?.args?.pending !== pending)) ? {...forwardSearchArgs, paginate: true, args: {read, pending}}: forwardSearchArgs,
}}

const onPageRemoved = (state: SearchState, action: any): SearchState => {
  let pages = [...state.searchResult];
	let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	let removed = pages.splice(index, 1);
	return {
		...state,
		searchResult: pages,
		selectedItem: (removed?.[0].pageId ?? -1) !== state.selectedItem.pageId ? state.selectedItem: pages.length > 0 ? pages[0] : {}
	}
};

const onPageUpdated = (state: SearchState, action: any): SearchState => {
  let pages = state.searchResult;
	let selectedPage = state.selectedItem;

  console.log("pages", pages);
  console.log("upddated", action.payload);
	let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	if(index !== -1){  
		pages[index] = action.payload;
  }
	else
		pages.unshift(action.payload);

	return {
		...state,
		selectedItem: selectedPage.pageId === action.payload.pageId ? {...action.payload}: selectedPage,
    searchResult: pages.filter(data => data).sort((a,b) => (moment(b.lastSent?.updatedAt ?? b.persistent.static.metadata.createdAt) as any) - (moment(a.lastSent?.updatedAt ?? a.persistent.static.metadata.createdAt) as any))
	};
};

const onPageFocus = (state: SearchState, action: any): SearchState => {
  // let pages = state.searchResult;
	// let index = pages.findIndex((page)=>{
	// 	return page.pageId === action.payload.pageId
	// });
	// if(index !== -1){
  //   pages.splice(index, 1)
  // }
  // pages.unshift(action.payload);
	return {
		...state,
		focusItem: action.payload,
    // searchResult: pages
	};
};


const selectFriendPage = (state: SearchState, action: any): SearchState => {
  let pages = state.searchResult;	
  let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	if(index !== -1){
    const temp = pages[0];
		pages[index] = temp;
    pages[0] = action.payload;
  }
	else
		pages.unshift(action.payload);

	return {
		...state,
		selectedItem: {...action.payload},
    searchResult: [...pages]
	};
};

const onPageReadBy = (state: SearchState, action: any): SearchState => {
  const readBy = [...(state.readBy || [])];
  const { pageId, read } = action.payload;
  readBy[pageId] = read;
  return {
    ...state,
    readBy,
  };
};

const onPageConnection = (state, action) => {
	return {
		...state,
		pageConnection: action.payload
	};
}

const onSearchPage = (state, action) => {
  let searchArgs = action.payload;
  console.log('on search page', searchArgs, searchArgs.reset)
	return {
		...state,
		searchArgs: searchArgs,
    searchPage: searchArgs.reset? initialState.searchPage: state.searchPage
	};
}

const onForwardPopupSearchPage = (state, action) => {
  let searchArgs = action.payload;
  console.log('on search page', searchArgs, searchArgs.reset)
	return {
		...state,
		forwardSearchArgs: searchArgs,
    forwardPopupSearchPage: searchArgs.reset? initialState.forwardPopupSearchPage: state.forwardPopupSearchPage
	};
}

const searchReducer = (
  state: SearchState = initialState,
  action: any
): SearchState => {

  switch (action.type) {
    case "GET_SEARCH":
      return getSearch(state);
    case "SET_SELECTED_ITEM":
      return getSelectedSearchItem(state, action);
    case "SET_SEARCH_RESULT":
      return getSearchResults(state, action);
    case "SET_MAP_TYPE":
      return { ...state, mapType: action.payload };
    case "SET_TWILIO_TOKEN":
      return { ...state, twilioToken: action.payload };
    case "SET_INCOMING_CALL":
      return { ...state, callNotification: action.payload };
    case "SET_INCOMING_CALL_ENDED":
      return { ...state, callNotification: action.payload };
    case "SET_SAVE_VIDEO_PROMPT":
      return { ...state, saveRecordingNotification: action.payload };
    case "SET_TWILIO_VIDEO_URL":
      return { ...state, twilioVideoURL: action.payload };
    case "RESET_STATE":
      return {
        ...state,
        saveRecordingNotification: undefined,
        callNotification: undefined,
        twilioVideoURL: undefined,
      };
    case "PAGE_UPDATE":
      return onPageUpdated(state, action);
    case "PAGE_CREATED":
      return { ...state, createdPageId: action.payload };
    case "CLEAR_CREATED_PAGE":
      return { ...state, createdPageId: undefined };
    case "PAGE_FOCUS":
      return onPageFocus(state, action);  
    case "PAGE_REMOVE":
      return onPageRemoved(state, action);
    case "PAGE_READ_BY":
      return onPageReadBy(state, action);
    case "PAGE_TYPING":
      return { ...state, pageTyping: action.payload };
    case "SEARCH_PAGE":
      return onSearchPage(state, action);
    case 'SET_CONNECTION': return onPageConnection(state, action);
    case "SET_USER_SEARCH_PAGE":
      return {
        ...state,
        userSearchPage: action.payload
      };
    case "SET_SEARCH_ADMIN_GROUP":
      return {
        ...state,
        adminSearchGroup: action.payload,
        groupSearchTimestamp:new Date().getTime()
      };  
    case "SET_FRIEND_SEARCH_PAGE":
      return {
        ...state,
        friendSearchPage: action.payload
      };
    case "SET_ALL_FRIEND_SEARCH_PAGE":
      return {
        ...state,
        friendPages: action.payload
      };
    case "SELECT_FRIEND_PAGE":
      return selectFriendPage(state, action);  
    case "SET_COPY_PAGE":
      return {
        ...state,
        copyPageId: action.payload
      };
    case "SET_FORWARD_SEARCH_RESULT":
      return getForwardPopupSearchResults(state, action);
    case "SEARCH_FORWARD_PAGES_LIST":
      return onForwardPopupSearchPage(state, action);
    default:
      return state;
  }
};

export default searchReducer;
